"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayName = function (Component) {
    if (typeof Component === 'string') {
        return Component;
    }
    if (!Component) {
        return;
    }
    return Component.displayName || Component.name || 'Component';
};
//# sourceMappingURL=utils.js.map